import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "no-margin-top split-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "section split-container__left" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Get Started"),
  /*#__PURE__*/_createElementVNode("hr", { class: "ruler--white" }),
  /*#__PURE__*/_createElementVNode("p", null, "To continue, you must create or join an organization.")
], -1)
const _hoisted_3 = { class: "section split-container__right" }
const _hoisted_4 = { class: "breadcrumbs overflow-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__item" }, " New Organization ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Create an Organization", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "form__input-description" }, " What your organization will be referred to as ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" .steamcord.link ")
const _hoisted_11 = { class: "form__input-description" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" The subdomain players will use to access your site, e.g. ")
const _hoisted_13 = { class: "anchor--primary" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Create organization ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dashboard_nav_bar = _resolveComponent("dashboard-nav-bar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_input_text_group = _resolveComponent("input-text-group")!
  const _component_loading_button = _resolveComponent("loading-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dashboard_nav_bar, { "show-linking-site": false }),
    _createElementVNode("main", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "breadcrumbs__item",
            to: "/dashboard"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6,
          _hoisted_7
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _hoisted_8,
          _createVNode(_component_base_input, {
            class: "full-width",
            placeholder: "Organization Name",
            error: _ctx.createOrgErrors.nameError,
            modelValue: _ctx.createOrgData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createOrgData.name) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["error", "modelValue"]),
          _hoisted_9,
          _createVNode(_component_base_input, {
            class: "full-width mobile",
            placeholder: "Subdomain",
            modelValue: _ctx.createOrgData.slug,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createOrgData.slug) = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"]),
          _createVNode(_component_input_text_group, {
            class: "desktop full-width",
            placeholder: "Subdomain",
            error: _ctx.createOrgErrors.slugError,
            modelValue: _ctx.createOrgData.slug,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createOrgData.slug) = $event)),
            modelModifiers: { trim: true }
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["error", "modelValue"]),
          _createElementVNode("p", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("a", _hoisted_13, " https://" + _toDisplayString(!!_ctx.createOrgData.slug ? _ctx.createOrgData.slug : 'your-subdomain') + ".steamcord.link ", 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_loading_button, {
              "button-type": "button--inverted",
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ], 32)
      ])
    ])
  ], 64))
}